<div
  class="bg-primary-color d-flex justify-content-between align-items-center text-light"
  style="border-radius: 5px; padding: 0.7em 1em"
>
  <div class="d-flex  wrapper gap-xl-5" style="width: 80%;flex-wrap: wrap;">
    <div class="d-flex gap-3 align-items-center">
      <span class="primary-text text-nowrap primary-font">{{label1}}</span>
      <span class="m-l-10 primary-text fw-bold text-truncate primary-font">{{infoDetails?.partNumber == undefined ? '-' : infoDetails?.partNumber}}</span>
    </div>
    <div class="d-flex gap-3 align-items-center">
      <span class="primary-text text-nowrap primary-font">{{label2}}</span>
      <span class="m-l-10 primary-text fw-bold text-truncate primary-font">{{infoDetails?.inStock == undefined ? '-' : infoDetails?.inStock}}</span>
    </div>
    <div class="d-flex gap-3 align-items-center">
      <span class="primary-text text-nowrap primary-font">{{label3}}</span>
      <span class="m-l-10 primary-text fw-bold text-truncate primary-font">{{infoDetails?.qtyAvailable == undefined ? '-' : infoDetails?.qtyAvailable}}</span>
    </div>  
    <div class="d-flex gap-3 align-items-center w-xl-20 w-md-100 w-lg-100">
      <span class="primary-text text-nowrap primary-font">{{label4}}</span>
      <span class="m-l-10 primary-text fw-bold text-truncate primary-font">{{infoDetails?.categoryGroupName == undefined ? '-' : infoDetails?.categoryGroupName}}</span>
    </div>
  </div>
  <div class="d-flex align-items-center hand mb-md-4 mb-lg-4 mb-xl-0">
    <img
      (click)="toggleIcon(isContactReminder)"
      src="./assets/SVGIcons/{{ isContactReminder ? 'uparrow' : 'downarrow' }}.svg"
      alt=""
    />
  </div>
</div>
